import React from 'react';

import useTranslation from '../../../../../hooks/useTranslation';
import AmountSummary from './AmountSummary';
import CategorySummary from './CategorySummary';
import FromAccountSummary from './FromAccountSummary';
import MessageSummary from './MessageSummary';
import ReceiverSummary from './ReceiverSummary';

import './SummaryDescription.scss';

const SummaryDescription: React.FC = () => {
    const translated = useTranslation();

    return (
        <>
            <ul className="summary-description__list">
                <FromAccountSummary />
                <ReceiverSummary />
                <AmountSummary />
                <CategorySummary />
                <MessageSummary />
            </ul>
            <p className="summary__payment-period">{translated.crossBorderPayment.summary.paymentPeriod}</p>
        </>
    );
};

export default SummaryDescription;
